



































import { Component, Prop, Vue } from "vue-property-decorator";
import { mapGetters } from "vuex";
import { IBlock } from "../../interfaces";

@Component({
  computed: {
    ...mapGetters("network", ["height"]),
  },
})
export default class BlockIdentity extends Vue {
  @Prop({ required: true }) public block: IBlock;
  @Prop({ required: true }) public prevHandler: () => void;
  @Prop({ required: true }) public nextHandler: () => void;

  private height: number;

  get isFirstBlock(): boolean {
    return this.block.height === 1;
  }

  get isLastBlock(): boolean {
    return this.block.height === this.height;
  }
}
